import { Component } from '@angular/core';

@Component({
  selector: 'app-viewrouting',
  templateUrl: './viewrouting.component.html',
  styleUrls: ['./viewrouting.component.scss']
})
export class ViewroutingComponent {

}
